import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { CONTRACT_ADDRESS } from "@/config";

export const SHORT_CA = `${CONTRACT_ADDRESS.slice(0, 6)}…${CONTRACT_ADDRESS.slice(-4)}`;

const ContractChip = ({ className = "" }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT_ADDRESS);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {}
  };
  return (
    <span data-testid="contract-chip" className={`inline-flex items-center gap-2 border border-arc-cyan/40 bg-arc-navy/70 px-2.5 py-1 font-mono text-[10px] tracking-[0.15em] ${className}`} title={CONTRACT_ADDRESS}>
      <span className="text-arc-silver/40">CA</span>
      <span className="text-arc-cyan">{SHORT_CA}</span>
      <button onClick={copy} data-testid="copy-contract-button" data-cursor="TARGET" aria-label="Copy contract address" className="text-arc-silver/60 hover:text-arc-cyan transition-colors">
        {copied ? <Check size={12} className="text-arc-green" /> : <Copy size={12} />}
      </button>
    </span>
  );
};

export default ContractChip;
